import { render, staticRenderFns } from "./RmrConfirmDialog.vue?vue&type=template&id=6ba3e292&scoped=true&"
import script from "./RmrConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./RmrConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./RmrConfirmDialog.vue?vue&type=style&index=0&id=6ba3e292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3e292",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
